import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { LocationType, UserProfile } from '../../../../@posturinn/client-react';
import { closeAllModals } from '../../../../actions/modalActions';
import { deletePaymentCard } from '../../../../actions/paymentActions';
import { deleteRecipient } from '../../../../actions/registerShipmentActions';
import { updateUserProfile } from '../../../../actions/userProfileActions';
import useRecipients from '../../../../hooks/useRecipients';
import IUserProfileReducer from '../../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../../reducers';
import Button from '../../../base/button';
import * as StyledModals from '../myShipmentsModals.styles';

interface Props {}

const Confirmation: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const deleteCard = cardId => {
		dispatch(deletePaymentCard(cardId));
	};

	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);
	const { userProfile } = userProfileReducer;

	const { recipients } = useRecipients(userProfile.userId);

	const updateDeliveryOption = () => {
		const newUserProfile: UserProfile = userProfile.clone();
		newUserProfile.preferredDeliveryMethodLocationId = '10';
		newUserProfile.preferredDeliveryMethod = LocationType.PackageLabelDecides;
		dispatch(updateUserProfile(newUserProfile));
	};

	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	const { modalHeading, modalCallback, modalQrCodeValue } = useSelector(({ modalReducer }) => modalReducer);

	const confirm = () => {
		switch (modalCallback) {
			case 'DELETE_CARD':
				deleteCard(modalQrCodeValue);
				break;
			case 'CLEAR_DELIVERYOPTION':
				updateDeliveryOption();
				break;
			case 'DELETE_RECIPIENT':
				dispatch(deleteRecipient(userProfile.userId, modalQrCodeValue, recipients));
				break;
			default:
				console.log('Confirmation callback method not found');
		}
		closeModal();
	};

	return (
		<StyledModals.Wrapper red>
			<div>{modalHeading}</div>
			<Button primary onClick={() => confirm()}>
				{t('yes')}
			</Button>
			<Button primary onClick={() => closeModal()}>
				{t('no')}
			</Button>
		</StyledModals.Wrapper>
	);
};

export default Confirmation;
